import {DataFetcherRequest} from '@aboutyou/data-fetcher';
import {GetPageResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.types';

type StoryPageStreamRequest = () => DataFetcherRequest<
  GetPageResponse & {nextState?: string}
>;

export const useIsInitialStoryStreamRequestEmpty = ({
  useRequest,
}: {
  useRequest: StoryPageStreamRequest;
}) => useRequest().data?.items?.length === 0;
